// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "size", "variant", "fallbackColor", "style", "fallbackClassName"],
  _excluded2 = ["className"],
  _excluded3 = ["className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn, ensureUnreachable } from "../../common/utils";
import { Heading } from "../Typography";
function getBorderRadius(size, variant) {
  if (variant === 'circle') {
    return 'cop-rounded-full';
  }
  switch (size) {
    case 'sm':
      return 'cop-rounded';
    case 'md':
      return 'cop-rounded';
    case 'lg':
      return 'cop-rounded-md';
    case 'xl':
      return 'cop-rounded-lg';
    default:
      ensureUnreachable(size);
  }
}
var Avatar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    variant = _ref.variant,
    fallbackColor = _ref.fallbackColor,
    style = _ref.style,
    fallbackClassName = _ref.fallbackClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var AVATAR_SIZE_MAP = {
    sm: 'cop-h-5 cop-w-5',
    md: 'cop-h-7 cop-w-7',
    lg: 'cop-h-10 cop-w-10',
    xl: 'cop-h-16 cop-w-16'
  };
  var avatarSize = AVATAR_SIZE_MAP[size];
  var avatarSizeWithBorder = "".concat(avatarSize, " ").concat(getBorderRadius(size, variant));
  var TEXT_SIZE_MAP = {
    sm: 'xs',
    md: 'sm',
    lg: 'lg',
    xl: '2xl'
  };
  var getTextColorFromFallbackColor = function getTextColorFromFallbackColor(color) {
    var colorHex = color.replace('#', '');
    var r = parseInt(colorHex.substr(0, 2), 16);
    var g = parseInt(colorHex.substr(2, 2), 16);
    var b = parseInt(colorHex.substr(4, 2), 16);
    var brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness >= 128 ? 'cop-text-primary' : 'cop-text-white';
  };
  var textColor = fallbackColor ? getTextColorFromFallbackColor(fallbackColor) : 'cop-text-primary';
  var memoizedStyles = React.useMemo(function () {
    // use fallback color if src is not provided
    if (fallbackColor && 'src' in props && !props.src) {
      return _objectSpread({
        backgroundColor: fallbackColor
      }, style);
    }
    return style !== null && style !== void 0 ? style : {};
  }, [fallbackColor, style, props]);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Root, _extends({
    ref: ref,
    className: cn("cop-relative cop-flex cop-border cop-border-solid cop-border-card-border ".concat(avatarSizeWithBorder, " cop-shrink-0 cop-overflow-hidden cop-bg-avatar-gray ").concat(textColor), className),
    style: memoizedStyles
  }, props), 'src' in props && /*#__PURE__*/React.createElement(AvatarImage, {
    src: props.src,
    alt: props.alt
  }), 'text' in props && /*#__PURE__*/React.createElement(AvatarFallback, null, /*#__PURE__*/React.createElement(Heading, {
    size: TEXT_SIZE_MAP[size],
    className: fallbackClassName
  }, props.text)));
});
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Image, _extends({
    ref: ref,
    className: cn('cop-aspect-square cop-h-full cop-w-full', className)
  }, props));
});
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(AvatarPrimitive.Fallback, _extends({
    ref: ref,
    className: cn('cop-bg-muted cop-flex cop-h-full cop-w-full cop-items-center cop-justify-center cop-rounded-full', className)
  }, props));
});
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
export { Avatar };
